document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // initMulticolumn();
  // initRichText();
  // initMulticolumnWithText();
});

// function initMulticolumn() {
//   const sections = document.querySelectorAll(".custom-mc");

//   sections.forEach((section) => {
//     const items = section.querySelectorAll(".custom-mc .mc-item");

//     if (!items.length) return;

//     // Animate TEXT instead of slide container (Swiper safe)
//     const texts = section.querySelectorAll(".custom-mc .mc-item");

//     gsap.set(texts, { opacity: 0, y: 40 });

//     gsap.to(texts, {
//       opacity: 1,
//       y: 0,
//       duration: 0.8,
//       stagger: 0.5,
//       ease: "power2.out",
//       scrollTrigger: {
//         trigger: section,
//         start: "top 85%",
//         once: true,
//       }
//     });

//   });
// }

// function initRichText() {
//   const sections = document.querySelectorAll(".custom-richtext");

//   sections.forEach((section) => {

//     // Set initial state for FULL section (border included)
//     gsap.set(section, { opacity: 0, y: 80 });

//     gsap.to(section, {
//       opacity: 1,
//       y: 0,
//       duration: 1,
//       ease: "power3.out",
//       scrollTrigger: {
//         trigger: section,
//         start: "top 85%",
//         once: true,
//       }
//     });

//   });
// }

function initMulticolumnWithText() {

}